import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=887c8912"
import script from "./MenuPage.js?vue&type=script&lang=js&external"
export * from "./MenuPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports